<template>
  <v-container fluid>
    <!-- <v-card > -->
      <v-toolbar
        dark
        color="primary lighten"
        :extended="$vuetify.breakpoint.smAndDown"
        >
        <v-select
          :items="['skymat', 'triton']"
          v-model="selectedCompany"
          label="Select Company"
          class="text-capitalize mt-6" 
          :loading="isloadingAppraisers"
        ></v-select> 
        <v-divider
          class="mx-4"
          inset
          vertical
          v-if="$vuetify.breakpoint.mdAndUp"
          ></v-divider>
          <v-spacer></v-spacer>
          <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <template v-slot:extension v-if="$vuetify.breakpoint.smAndDown">
        <v-text-field
            v-model="search"
            hide-details
            append-icon="mdi-magnify"
            single-line
            label="Search"
            :loading="isSearching"       
            @click:append="fetchAppraisers"
            :disabled="!selectedCompany"
        ></v-text-field>
      </template>
        <v-text-field
        v-if="$vuetify.breakpoint.mdAndUp"
            v-model="search"
            hide-details
            append-icon="mdi-magnify"
            single-line
            label="Search"
            :loading="isSearching"       
            @click:append="fetchAppraisers"
            :disabled="!selectedCompany"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn icon @click="addAppraiserDialog()">
            <v-icon > mdi-account-plus</v-icon>
        </v-btn>                 
          
        <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>   
      </v-toolbar> 
      
      
      <v-data-table
        :headers="headersExp"
        :items="localFilteredAppraisers"
        :search="search"     
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="appr_code"
        show-expand
        class="elevation-1"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        :server-items-length="pagination.totalItems"
        :loading="isloadingAppraisers"
        :v-model="pagination"
        @pagination="fetchAppraisers"
        
      >
    <template v-slot:top>
    <v-toolbar flat :extended="$vuetify.breakpoint.smAndDown">
        <h2 class="headline font-weight-bold">Appraisers List</h2>
        <!-- <v-toolbar-title>Appraisers</v-toolbar-title> -->
        <v-spacer v-if="$vuetify.breakpoint.smAndDown"></v-spacer>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer v-if="$vuetify.breakpoint.smAndDown"></v-spacer>
        <v-btn icon @click="fetchAppraisers"  :disabled="!selectedCompany">
          <v-icon> mdi-refresh </v-icon>
        </v-btn>  

        <v-spacer></v-spacer>   
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
        <template v-slot:extension v-if="$vuetify.breakpoint.smAndDown">
        <v-switch
          v-model="singleExpand"
          label="Single expand"
          class="mt-2"
        ></v-switch>  

        <v-spacer></v-spacer>
        <v-divider   
          class="mx-4"
          inset
          vertical
        ></v-divider>  
        <v-spacer></v-spacer> 
        <v-switch
          v-model="lineitem"
          label="Line Items"
          class="mt-2"
        ></v-switch>
      </template>

        <v-switch
          v-if="$vuetify.breakpoint.mdAndUp"
          v-model="singleExpand"
          label="Single expand"
          class="mt-2"
        ></v-switch> 
       
        <v-divider   
          class="mx-4"
          inset
          vertical 
          v-if="$vuetify.breakpoint.mdAndUp" 
        ></v-divider>  
        
        <v-switch
        v-if="$vuetify.breakpoint.mdAndUp"
          v-model="lineitem"
          label="Line Items"
          class="mt-2"
        ></v-switch>

      </v-toolbar>
    </template>
    <template v-slot:item.isSelfEvaluation="{ item }"> 
        <v-icon 
            v-if="item.isSelfEvaluation" 
            color="green">
            mdi-check-circle
        </v-icon>   
        <v-icon 
            v-else
            color="grey">
            mdi-minus-circle-off-outline
        </v-icon>    
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">         
        <span v-for="(chipRow, index) in getEXPChipRows(item.appraisees)" :key="index" class="chip-row">
          <v-chip-group class="d-flex flex-wrap">
            <v-tooltip bottom v-for="appraisee in chipRow" :key="appraisee.id">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="appraisee.isAppraised ? 'green' : 'blue'"
                  class="ma-1"
                  >
                  {{ appraisee.appe_code }}
                </v-chip>
              </template>
              <span>{{ appraisee.appe_name }}</span>
            </v-tooltip>
          </v-chip-group>
        </span>
      </td>
    </template>
    <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="openViewModal(item)">
          mdi-eye
        </v-icon>
        <!-- <v-icon small class="mr-2" @click="editAppraiserDialog(item)">
          mdi-pencil
        </v-icon> -->
        <v-icon small @click="deleteAppraiser(item)">
          mdi-delete
        </v-icon>
    </template>    
      </v-data-table>
    <!-- </v-card> -->

  <!-- View Details Modal -->
  <v-dialog v-model="detailsDialog" max-width="600px" persistent>
    <v-card>
      <v-toolbar flat color='primary'>         
      <v-toolbar-title> Appraisee Detailed View</v-toolbar-title>
      <v-spacer></v-spacer>    
        <v-btn icon fab small> 
        <v-icon> mdi-format-list-group-plus</v-icon>
      </v-btn> 
        <v-hover>
            <template v-slot:default="{ hover }">
            <v-btn 
              icon 
              @click="closeDetailDialog" 
              :color="hover ? 'red' : 'default'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            </template>
        </v-hover>
      </v-toolbar>
      <v-card-title>        
        <!-- Appraisee Detailed View -->
        ( {{ selectedAppraiser?.appr_code }})- {{ selectedAppraiser?.appr_name }}
      </v-card-title>
      <v-card-subtitle class="pb-0">
        {{ selectedAppraiser?.appr_designation }} - {{ selectedAppraiser?.appr_department }}
      </v-card-subtitle>
      <v-card-text>
        <v-list>
          <v-list-item v-for="appraisee in selectedAppraiser.appraisees" :key="appraisee.id">
            <v-list-item-content>
              <v-list-item-title>({{ appraisee.appe_code }}) - {{ appraisee.appe_name }} </v-list-item-title>
              <v-list-item-subtitle> {{ appraisee.appe_designation }} - {{ appraisee.appe_department }}, {{ appraisee.appe_company.toUpperCase()}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn :disabled="appraisee.isAppraised" icon color="red" @click="deleteAppraisee(appraisee)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>            
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red darken-1" text @click="closeDetailDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Edit/Create Appraiser Dialog -->
  <v-dialog v-model="editDialog" max-width="600px" persistent>
    <v-card>
      <v-toolbar  color="primary" dark> 
        <v-card-title>
          {{ appraiserFormData.appr_id ? `Edit Appraiser : ${appraiserFormData.appr_name}` : 'New Appraiser' }}
        </v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon @onclick="getAllEmployees">
            <v-icon > mdi-refresh </v-icon>
        </v-btn>    
        <!-- <v-switch 
          v-if="!appraiserFormData.appr_id "
          v-model="multipleMode" 
          label="Multiple Selection Mode" 
          disabled
        ></v-switch>
        <v-switch
          v-else
          v-model="autoUpdate"
          label="Auto Update"
        ></v-switch> -->
        <v-hover>
            <template v-slot:default="{ hover }">
            <v-btn 
              icon 
              @click="closeEdit" 
              :color="hover ? 'red' : 'default'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            </template>
        </v-hover>
      </v-toolbar>
      <v-card-subtitle>
        <p class="font-italic">** Inorder to update existing appraisers with new appriasees you can add again here.</p>
      </v-card-subtitle>
      <v-card-text> 
      <v-form ref="editForm" v-model="editformvalid">
        <v-autocomplete
          v-if="!appraiserFormData.appr_id"
          v-model="appraiserFormData.appraisers"
          :items="availableAppraisers"
          :label="multipleMode ? 'Appraisers' : 'Appraiser'"
          :rules="[v => !!v || 'Appraiser is required']"
          required
          return-object
          :multiple="multipleMode"
          chips
          item-text="appr_name" 
          item-value="appr_id"
          max-width="400px"
        >
        <template v-slot:item="{ item }">                
          <v-list-item-avatar>
            <!-- Use employee photo if available, otherwise use mdi-account icon as the avatar -->
            <v-img v-if="item.appr_avathar" :src="item.appr_avathar"></v-img>
            <v-icon v-else>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content >
            <v-list-item-title v-text="formatName(item.appr_name)"></v-list-item-title>
            <v-list-item-subtitle>{{item.appr_code }} - {{ item.appr_designation }}</v-list-item-subtitle>
          </v-list-item-content>                
        </template>
          
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  No Data Available - 
                  <span @click="getAllEmployees(true)" 
                    style="color: blue; 
                    cursor:pointer;">
                    Search on Server
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>

        <!-- Combobox for appraisees -->
        <v-combobox
          v-model="appraiserFormData.appraisees"
          :items="availableAppraisees"
          label="Select Appraisees"
          item-text="appe_name"
          item-value="appe_code"
          multiple
          chips             
          prepend-icon="mdi-account-group-outline"
          solo
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              :close="!item.isAppraised"
              @click="selectAppraisee(item)"
              :disabled="item.isAppraised"
              @click:close="removeAppraisee(item)"
            >
              <v-avatar
                v-if="item.appe_name"
                class="accent white--text"
                left
                v-text="item.appe_name.slice(0, 1).toUpperCase()"
              ></v-avatar>
            {{ formatName(item.appe_name) }}
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-avatar>
              <!-- Use employee photo if available, otherwise use mdi-account icon as the avatar -->
              <v-img v-if="item.appe_avathar" :src="item.appe_avathar"></v-img>
              <v-icon v-else>mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="formatName(item.appe_name)"></v-list-item-title>
              <v-list-item-subtitle v-text="item.appe_code"></v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  No Data Available - 
                  <span @click="getAllEmployees(refresh = true)" style="color: blue; cursor:pointer;">Search on Server</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </v-form>
      </v-card-text>
      <v-card-actions>        
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="closeEdit">Cancel</v-btn>
      <v-btn v-if="!appraiserFormData.id"  :disabled="autoUpdate" color="green darken-1" text @click="submitNewAppraiser">Save New </v-btn>
      <v-btn v-else :disabled="isEditsUpdatable" color="green darken-1" text @click="submitChanges">Save Update</v-btn>  
    </v-card-actions>
   </v-card>
  </v-dialog>
  </v-container>
</template>

<script>
import dynamic_axios from "../services/dynamic_axios";
// import Axios from "axios";
import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      expanded: [],
      search:'',
      singleExpand: false,
      lineitem:false,
      detailsDialog: false,
      multipleMode: true,
      autoUpdate: false,
      selectedAppraiser: {},
      editDialog: false,
      appraiserFormData: {
        appr_id: null,
        appr_name: '',
        appr_code: '',
        appr_desg_id: '',
        appr_dept_id: '',
        appr_designation: '',
        appr_department: '',
        appr_company: '',
        appraisers: [],
        appraisees: [], // This will hold the IDs of the selected appraisees
        appraiseesQueAddition: [],
        appraiseesQueDeletion: [],
      },
      isUpdating: false,
      editformvalid: true,
      skymatEmployees:[],
      tritonEmployees: [],
      selectedCompany:'',
      lastErrorToast: null,
      isloadingEmployees: false,
      isloadingAppraisers: false,
      headersExp : [
        // { text: 'Doc No.', value: 'appr_docno' },
        { text: 'Emp Code', value: 'appr_code' },
        { text: 'Appraiser', value: 'appr_name' },       
        { text: 'Designation', value: 'appr_designation' },
        { text: 'Department', value: 'appr_department' },
        { text: 'Company', value: 'appr_company' },
        { text: 'Self', value: 'isSelfEvaluation' },
        // { text: 'Appraisees', value: 'appraisees' },
        { text: 'Action', value: 'action', sortable: false },
        { text: '', value: 'data-table-expand' },
      ],
      appraisers:[],
      filteredAppraisers: [],
      isSearching: false,
      pagination: { page: 1,
         itemsPerPage: 10, 
         totalItems: 0 },
      filter_token: '',
    };
  },
  computed: {   
    user() {     
      return this.$store.getters.factsuser;      
    },
    userProfile(){
      return this.$store.getters.userProfile;
    },
    fbuserdata() {
      return this.$store.getters.fbuserdata;
    },
    perferedAPI() {
      return this.$store.getters.perferedAPI;
    }, 
    isMobile() {
      return window.innerWidth <= 600; // or whatever threshold you like
    },
    appraisersModel: {
      get() {
        // Return first element if in single mode, or full array if in multiple mode
        return this.multipleMode ? this.appraiserFormData.appraisers : (this.appraiserFormData.appraisers[0] || null);
      },
      set(value) {
        // Set the whole array in multiple mode or wrap the single object in an array if in single mode
        this.appraiserFormData.appraisers = this.multipleMode ? value : [value];
      }
    },
    isEditsUpdatable() {
      if (!this.autoUpdate && (this.appraiserFormData?.appraiseesQueAddition?.length > 0 || this.appraiserFormData?.appraiseesQueDeletion?.length > 0)) {
        return true;
      } else return false
    },
   
    availableAppraisers() {
    let appraiseeIds = this.appraiserFormData.appraisees.map(appraisee => appraisee.appe_id);
    let appraiserIds = this.appraisers.map(appraiser => appraiser.appr_id);

    return this.allEmployees.filter(emp => {
      return !emp.isAppraiser &&
             !appraiseeIds.includes(emp.emp_id) &&
             !appraiserIds.includes(emp.emp_id);
    }).map(emp => ({
      appr_id: emp.emp_id,
      appr_name: emp.emp_name,
      appr_code: emp.emp_code,
      appr_desg_id:emp.emp_desg_id,          
      appr_dept_id: emp.emp_dept_id,
      appr_designation: emp.emp_designation,
      appr_department: emp.emp_department,
      appr_company: emp.emp_company,
      appr_avathar: emp.emp_avathar,
      appr_reportingto: emp.emp_reportingto,
    }));
    },
    availableAppraisees() {
      const currentAppraiserId = this.appraiserFormData.appr_id;
      return this.allEmployees.filter(emp => emp.emp_id !== currentAppraiserId && !emp.isAppraiser).map(emp => ({
        appe_id: emp.emp_id,
        appe_name: emp.emp_name,
        appe_code: emp.emp_code,
        appe_desg_id:emp.emp_desg_id,          
        appe_dept_id: emp.emp_dept_id,
        appe_designation: emp.emp_designation,
        appe_department: emp.emp_department,
        appe_company: emp.emp_company,
        appe_avathar: emp.emp_avathar,
        appe_reportingto: emp.emp_reportingto,
      }));
    },
    localFilteredAppraisers() {
      if(!this.appraisers) return;
      if (!this.search) return this.appraisers;
      return this.appraisers.filter(appraiser => 
        Object.values(appraiser).some(value => 
          value && value.toString().toLowerCase().includes(this.search.toLowerCase())
        )
      );
    },
  },
  watch:{
    skymatEmployees:{
      handler(){
        this.updateAllEmployees();
      },
      immediate:true
    },
    tritonEmployees:{
      handler(){
        this.updateAllEmployees();
      },
      immmediate:true
    },
    fbuserdata(newValue) {
        this.selectedCompany = newValue.company; 
    },
    search: {
      handler() {
        this.debouncedSearch();
      },
    },
    selectedCompany(newValue,oldValue){
      if  (newValue != oldValue){
        this.switchCompany();
      }
    }    
  },
  methods: {  
    async getEmployees(company) {
      this.isLoadingEmployees = true;  // Start loading state
      try {
        // Extracting user details safely
        const employ_id = this.user.USER_EMP_DOCNO;
        const EMPMST_DESG_DOCNO = this.userProfile.EMPMST_DESG_DOCNO;
        // const dep = this.userProfile.EMPMST_UD_TXT5;
        const USER_LOGINID = this.user.USER_LOGINID;
        const purpose = "appraisal_assign"

        // Constructing the query string
        const params = new URLSearchParams({
          employ_id,
          EMPMST_DESG_DOCNO,
          // dep,
          USER_LOGINID,
          purpose
        }).toString();

        const response = await dynamic_axios.get(`employees?${params}`, {
          apiName: company  // Specify which API configuration to use
        });
        // console.log( response.data.employees)
        const employees = response.data.employees
        .filter(emp => emp.EMPMST_DOCUMENT_STATUS_DOCNO === "ACT")
        .map(emp => ({
          emp_id: emp.EMPMST_DOCNO,
          emp_name: emp.EMPMST_NAME,
          emp_code: emp.EMPMST_DOCNO,
          emp_desg_id: emp.EMPMST_DESG_DOCNO,
          emp_dept_id: emp.EMPMST_DEPT_DOCNO,
          emp_designation: emp.DESIG_DESC,
          emp_department: emp.PDEPTMST_DESC,
          emp_reportingto : emp.EMPMST_REPORTTO_DOCNO,          
          emp_avathar:emp.EMPMST_PHOTO,
          emp_company: company,
          isAppraiser: emp.isAppraiser || false
        }));

        if (company === 'skymat') {
          this.skymatEmployees = employees;
        } else if (company === 'triton') {
          this.tritonEmployees = employees;
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
        this.isLoadingEmployees = false;  // End loading state
      }
    },
    async getAllEmployees(refresh = false){
      if (refresh){
        await this.$store.dispatch("get_employee", { employ_id: this.user.USER_EMP_DOCNO})
        await Promise.all([
          this.getEmployees('triton'),
          this.getEmployees('skymat')
        ])
      } else {
        // Only fetch if arrays are undefined or empty
        if (!this.skymatEmployees.length) {
          await this.getEmployees('skymat');
        }
        if (!this.tritonEmployees.length) {
          await this.getEmployees('triton');
        }
      }
    },  
    updateAllEmployees(){
      this.allEmployees = [
        ...this.skymatEmployees,
        ...this.tritonEmployees]        
        .map(emp => ({
          ...emp,
          group: `${emp.company} - ${emp.department}`
        })
      );
    },
    openViewModal(appraiser) {
      this.selectedAppraiser = appraiser;
      this.detailsDialog = true;
    },
    switchCompany() {
      // this.selectedCompany = companyName;
      this.resetAppraisers();
      this.fetchAppraisers();
    },
    resetAppraisers() {
      this.appraisers = [];
      this.pagination = { page: 1, itemsPerPage: 10, totalItems: 0 };
      this.filter_token = '';
    },
    async handleSearch() {
      this.isSearching = true;
      this.filteredAppraisers = this.localFilteredAppraisers;

      if (this.filteredAppraisers.length === 0) {
        // If no local results, fetch from server
        await this.fetchAppraisers();
      }

      this.isSearching = false;
    },
    async fetchAppraisers() {
        // console.log('fetchAppraisers called', new Date().toISOString());
        if (!this.selectedCompany) return;
        if (this.isLoadingAppraisers) return;
        this.isloadingAppraisers = true;
        const params = {
          search: this.search,
          user_id: this.user.USER_LOGINID,
          lineitem : this.lineitem,
          page: this.pagination.page,
          per_page: this.pagination.itemsPerPage,
          filter_token: this.filter_token
        };
        try {
          const response = await dynamic_axios.get(`/appraisal/appraisers`, {
            params,
            apiName: this.selectedCompany
          });

          this.appraisers = response.data.appraisers;
          // console.log("response.data.appraisers",response.data.appraisers)
          this.pagination.totalItems = response.data.total ||  this.pagination.totalItems;
          this.pagination.current_page = response.data.current_page;
          this.filter_token = response.data.filter_token;
        } catch (error) {
          // this.$toast.error(error.response.data.message);
          // console.error("Error fetching Appraisers:", error);
          // Check if it's been at least 3 seconds since the last error toast
          const now = Date.now();
          if (!this.lastErrorToast || (now - this.lastErrorToast) > 3000) {
            this.$toast.error(error.response?.data?.message || 'An error occurred');
            this.lastErrorToast = now;
          }
          // console.error("Error fetching Appraisers:", error);
        } finally {
          this.isloadingAppraisers = false;
        }
    }, 
    async deleteAppraiser(appraiser) {
      try {
          const result = await this.$swal({
              title: 'Are you sure?',
              text: `You will not be able to recover this appraiser: ${appraiser?.appr_name}`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!'
          });

          if (result.isConfirmed) {
            const user_id = this.user.USER_LOGINID; // Assume this is properly fetched
            const company = appraiser.appr_company; // Assuming company info is part of the appraiser object
            const appraiser_id = appraiser.appr_id; // Ensure this is correct

            const response = await dynamic_axios.delete(`/appraisal/appraisers/${appraiser_id}`, {
              params: {
                  user_id,
                  company // Additional parameters if needed by the backend
              },
              headers: {
                  'Content-Type': 'application/json' // Ensuring JSON content type
              },
              apiName: company // Using dynamic axios configuration based on the company
            });

            if (response.status === 200) {  // Corrected status code check
                this.$toast.success("Deleted successfully");
                // Update the UI by filtering out the deleted appraiser
                this.appraisers = this.appraisers.filter(a => a.appr_id !== appraiser.appr_id);
            } else if (response.status === 401) {
                this.$toast.warning("Unauthorized");
            } else {
                // Handling different types of error messages from the server
                this.$toast.error("Failed to delete the appraisee");
            }
          }
      } catch (error) {
          this.$toast.error("Error processing your request"+ error?.response?.data?.message);
      }
    }, 
    async deleteAppraisee(appraisee) {
      try {
          const result = await this.$swal({
              title: 'Are you sure?',
              text: `You will not be able to recover this appraisee: ${appraisee?.appe_name}`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!'
          });
          // console.log('appraisee',appraisee)

          // console.log('selectedAppraiser',this.selectedAppraiser)
          // console.log('appraisers',this.appraisers)

          if (result.isConfirmed) {
              const user_id = this.user.USER_LOGINID; // Assume this is properly fetched
              const appraisee_id = appraisee.appe_id; // Ensure this is correct
              const company = this.selectedAppraiser?.appr_company
              const response = await dynamic_axios.delete(`/appraisal/appraisee/${appraisee_id}`, {
                  params: { user_id,company }, // Send user_id as a query parameter if needed for authorization
                  apiName: company,
                  headers: {
                    'Content-Type': 'application/json' // Ensuring JSON content type
                  },
              });

              if (response.status === 200) {
                  this.$toast.success('Appraisee deleted successfully!');
                  // Update the UI by filtering out the deleted appraisee
                  // this.selectedAppraiser?.appraisees = this.selectedAppraiser?.appraisees.filter(a => a.appe_id !== appraisee.id);
                   // Find the selected appraiser in the appraisers array
                  const selectedAppraiserIndex = this.appraisers.findIndex(a => a.appr_id === this.selectedAppraiser.appr_id);
                  if (selectedAppraiserIndex !== -1) {
                      // Filter the appraisees array within the found appraiser
                      const updatedAppraisees = this.appraisers[selectedAppraiserIndex].appraisees.filter(a => a.appe_id !== appraisee.appe_id);
                      
                      // Update the appraisees array reactively
                      this.$set(this.appraisers[selectedAppraiserIndex], 'appraisees', updatedAppraisees);
                      
                      // Optionally, update the selectedAppraiser if it's displayed elsewhere
                      this.selectedAppraiser = { ...this.selectedAppraiser, appraisees: updatedAppraisees };
                  }
                } else if (response.status === 401) {
                  this.$toast.warning("Unauthorized");
              } else {
                  // Handling different types of error messages from the server
                  this.$toast.error(`Failed to delete the appraisee: ${response.data.message}`);
              }
          }
      } catch (error) {
          console.error('Failed to delete appraisee:', error);
          this.$toast.error('Error processing your request: ' + (error.response?.data?.message || 'Failed to delete appraisee.'));
      }
    },
    editAppraiserDialog(appraiser = null) {          
      if (appraiser) {
        this.multipleMode=false;
        // this.appraiserFormData = JSON.parse(JSON.stringify(appraiser));
        this.appraiserFormData.appr_id = appraiser.appr_id
        this.appraiserFormData.appr_name = appraiser.appr_name
        this.appraiserFormData.appr_code = appraiser.appr_code
        this.appraiserFormData.appr_desg_id= appraiser.appr_desg_id
        this.appraiserFormData.appr_dept_id = appraiser.appr_dept_id
        this.appraiserFormData.appr_designation= appraiser.appr_designation
        this.appraiserFormData.appr_department = appraiser.appr_department
        this.appraiserFormData.appr_company = appraiser.appr_company 
        this.appraiserFormData.appraisees = appraiser.appraisees 
        
        // Ensure all potentially undefined properties are initialized
        // this.appraiserFormData.appraisers = this.appraiserFormData.appraisers || [];
        // this.appraiserFormData.appraisees = this.appraiserFormData.appraisees || [];
      } else {
        this.resetappraiserFormData(); // Reset to default structure
      }
      this.editDialog = true;
    },
    addAppraiserDialog() {          
      this.resetappraiserFormData(); 
      this.editDialog = true;
    },
    removeAppraiser(appr) {
      if (this.multipleMode) {
        this.appraiserFormData.appraisers = this.appraiserFormData.appraisers.filter(a => a.id !== appr.appr_id);
      } else {
        this.appraiserFormData.appraisers = [];
      }
    },    
    addAppraiseeToAppraiser(appraiserId, newAppraisee) {
      const appraiserIndex = this.appraisers.findIndex(appraiser => appraiser.id === appraiserId);
      if (appraiserIndex === -1) {
        console.error('Appraiser not found');
        return;
      }

      // Clone, modify, and replace the appraisees array to maintain reactivity
      const newAppraisees = [...this.appraisers[appraiserIndex].appraisees, newAppraisee];
      this.$set(this.appraisers[appraiserIndex], 'appraisees', newAppraisees);

      // console.log('Appraisees after addition:', this.appraisers[appraiserIndex].appraisees);
    },
    removeAppraiseeFromAppraiser(appraiserId, appraiseeId) {
      const appraiserIndex = this.appraisers.findIndex(appraiser => appraiser.id === appraiserId);
      if (appraiserIndex === -1) {
        console.error('Appraiser not found');
        return;
      }

      // Find the appraisee and remove it from the array
      const appraisees = this.appraisers[appraiserIndex].appraisees;
      const appraiseeIndex = appraisees.findIndex(appraisee => appraisee.id === appraiseeId);
      if (appraiseeIndex === -1) {
        console.error('Appraisee not found');
        return;
      }

      // Create a new array without the appraisee
      const newAppraisees = [...appraisees.slice(0, appraiseeIndex), ...appraisees.slice(appraiseeIndex + 1)];
      this.$set(this.appraisers[appraiserIndex], 'appraisees', newAppraisees);

      // console.log('Appraisees after removal:', this.appraisers[appraiserIndex].appraisees);
    },
    resetappraiserFormData() {
      this.appraiserFormData = {
        appr_id: null,        
        appr_name: '',
        appr_code: '',
        appr_desg_id: '',
        appr_dept_id: '',
        appr_designation: '',
        appr_department: '',
        appr_company: '',
        appraisers: [],
        appraisees: [],
        appraiseesQueAddition : [],
        appraiseesQueDeletion :[],
      };
    },
    async submitNewAppraiser() {
      if (this.$refs.editForm.validate()) {
        this.isSubmitting = true;

        // Shared appraisees setup
        const sharedAppraisees = this.appraiserFormData.appraisees.map(appraisee => ({
          appe_emp_name: appraisee.appe_name,
          appe_emp_code: appraisee.appe_code,
          appe_desg_id: appraisee.appe_desg_id,
          appe_dept_id: appraisee.appe_dept_id,
          appe_designation: appraisee.appe_designation,
          appe_department: appraisee.appe_department,
          appe_company: appraisee.appe_company,
          isAppraised: false
        }));

        if (this.multipleMode) {
          // Group appraisers by company
          let appraisersGroupedByCompany = {};
          this.appraiserFormData.appraisers.forEach(appraiser => {
            const company = appraiser.appr_company;
            // console.log("appraiser.company;",company)
            if (!appraisersGroupedByCompany[company]) {
              appraisersGroupedByCompany[company] = [];
            }
            appraisersGroupedByCompany[company].push({
              id: appraiser.id || '',
              slno: appraiser.slno || '',
              appr_emp_name: appraiser.appr_name,
              appr_emp_code: appraiser.appr_code,
              appr_desg_id: appraiser.appr_desg_id,
              appr_dept_id: appraiser.appr_dept_id,
              appr_designation: appraiser.appr_designation,
              appr_department: appraiser.appr_department,
              appr_company: appraiser.appr_company,              
            });
          });

          const companyKeys = Object.keys(appraisersGroupedByCompany);
          if (companyKeys.length === 1) {
              // If all appraisers are from the same company, send one request
              const company = companyKeys[0];
              await this.postAppraisers(company, appraisersGroupedByCompany[company], sharedAppraisees);
          } else {
              // If appraisers are from multiple companies, send multiple requests
              const promises = companyKeys.map(company => this.postAppraisers(company, appraisersGroupedByCompany[company], sharedAppraisees));
              await Promise.all(promises);
          }
        } else {
          // Single appraiser mode
          // const appraiserData = this.appraiserFormData.appraisers; // Assuming this is already formatted as needed
          const appraiser = {
            appr_id: this.appraiserFormData?.appr_id,        
            appr_name: this.appraiserFormData?.appr_name,
            appr_code: this.appraiserFormData?.appr_code,
            appr_desg_id: this.appraiserFormData?.appr_desg_id,
            appr_dept_id: this.appraiserFormData?.appr_dept_id,
            appr_designation: this.appraiserFormData?.appr_designation,
            appr_department: this.appraiserFormData?.appr_department,
            appr_company: this.appraiserFormData?.appr_company,
          }
         
          // console.log(this.appraiserFormData?.appr_company); // but in case of single mode it empty need to fix
          await this.postAppraisers(appraiser.appr_company, [appraiser], sharedAppraisees);
          
        }
        this.isSubmitting = false;
        this.editDialog = false;
        this.resetappraiserFormData();
      }
    },
    // Helper method to post appraisers to the API
    async postAppraisers(company, appraisers, appraisees) {
      // console.log(company, appraisers, appraisees);
      // console.log(appraisers, appraisees)
      try {
        const response = await dynamic_axios.post('/appraisal/appraisers', {
          appraisers: appraisers,
          appraisees: appraisees,
          user_id: this.user?.USER_LOGINID
        }, {
          apiName: company
        });        
        // console.log("response.data",response.data)
        // console.log("response",response)
       
        if (response.data.status === "success") {
          this.$toast.success(`Appraisers and their appraisees updated successfully for ${company}.`, response.data);
          this.processAppraisers(response.data.data.appraisers_processed);     
        } else {
            console.error('Failed to process appraisers:', response.data);
        }
        return { success: true, company: company };
      } catch (error) {
        this.$toast.error(`Error updating appraisers for ${company}: ${error.message}`);
        return { success: false, company: company };
      }
    },
    processAppraisers(processedAppraisers) {
      processedAppraisers.forEach(processedAppraiser => {
        const index = this.appraisers.findIndex(appr => appr.appr_id === processedAppraiser.appr_id);

        if (index !== -1) {
          // Update existing appraiser
          this.appraisers[index].appr_updated_at = processedAppraiser.appr_updated_at;
          this.appraisers[index].appr_updated_by = processedAppraiser.appr_updated_by;
          
          // Update appraisees by concatenating new ones to the existing list
          if (processedAppraiser.appraisees && processedAppraiser.appraisees.length > 0) {
            this.appraisers[index].appraisees = [
              ...this.appraisers[index].appraisees,
              ...processedAppraiser.appraisees
            ];
          }
        } else {
          // Add new appraiser if not found
          this.appraisers.push(processedAppraiser);
        }
      });
    },
    updateOrAppendAppraisersAndAppraisees(serverData) {
        serverData.forEach(data => {
            const appraiserIndex = this.appraisers.findIndex(a => a.appr_id === data.appr_id);
            
            if (appraiserIndex !== -1) {
                // Existing appraiser, update details
                let appraiser = this.appraisers[appraiserIndex];
                
                // Directly updating appraiser's properties
                Object.assign(appraiser, data);

                // Manage appraisees, ensuring reactivity for each change
                data.appraisees.forEach(appraiseeData => {
                    const appraiseeIndex = appraiser.appraisees.findIndex(a => a.appe_id === appraiseeData.appe_id);
                    if (appraiseeIndex !== -1) {
                        // Update existing appraisee
                        this.$set(appraiser.appraisees, appraiseeIndex, {...appraiser.appraisees[appraiseeIndex], ...appraiseeData});
                    } else {
                        // Add new appraisee
                        appraiser.appraisees.push(appraiseeData);
                    }
                });

                // Reactively set updated appraiser back to the array
                this.$set(this.appraisers, appraiserIndex, appraiser);
            } else {
                // New appraiser, add to the list with its appraisees
                this.appraisers.push({
                    ...data,
                    appraisees: data.appraisees.map(ap => ({...ap}))
                });
            }
        });

        // Optionally, you might need to force an update if you're seeing issues with reactivity
        this.$forceUpdate();
    },
    closeEdit() {
      this.resetappraiserFormData();
      this.editDialog = false;
    },    
    closeDetailDialog() {
      this.selectedAppraiser = {},
      this.detailsDialog = false;
    },
    getEXPChipRows(appraisees) {
      const maxChips = 14;
      if (!appraisees) return [];
  
      const rows = [];
      for (let i = 0; i < appraisees.length; i += maxChips) {
        rows.push(appraisees.slice(i, i + maxChips));
      }
      return rows;
      // if(appraisees){
      //   return [
      //     appraisees.slice(0, maxChips),
      //     ...(appraisees.length > maxChips ? [appraisees.slice(maxChips)] : [])
      //   ];
      // }else return 0;
    },
    handleExpand(event) {
      if (this.singleExpand) {
        this.expanded = event.value ? [event.item] : []
      }
    },
    // customFilter(value, search, item) {
    //   return value != null &&
    //     search != null &&
    //     typeof value === 'string' &&
    //     value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    // },
    queueAddition(appraisee) {
      this.appraiserFormData.appraiseesQueAddition.push({
        appe_emp_code: appraisee.emp_code,
        appe_emp_name: appraisee.emp_name,
        appe_amp_reporting_to: appraisee.reportingTo || '',
        appe_company: appraisee.company,
        appe_department: appraisee.department,
        appe_designation: appraisee.designation,
        appe_user_uid: appraisee.uid || '',
      });
      // this.$toast.info('Appraisee queued for addition.');
    },
    queueDeletion(appraiseeId) {
      this.appraiserFormData.appraiseesQueDeletion.push(appraiseeId);
      // this.$toast.info('Appraisee queued for deletion.');
    },
    selectAppraisee(appraisee) {
      if (this.autoUpdate) {
        // If autoUpdate is true, send the add request immediately
        this.addAppraisee([appraisee]);  // Adjusted to handle a list of one for consistency
      } else {
        // Otherwise, queue the addition
        this.queueAddition(appraisee);
        this.$toast.info('Appraisee added to addition queue.');
      }
    },
    removeAppraisee(appraisee) {
      if (this.autoUpdate) {
        // If autoUpdate is true, send the delete request immediately
        this.deleteAppraisee(appraisee.id);
      } else {
        // Otherwise, queue the deletion
        this.queueDeletion(appraisee.id);
        this.$toast.info('Appraisee added to deletion queue.');
      }
    },
    async addAppraisee(appraisees) {
      try {
        await dynamic_axios.put('/appraisal/add_appraisee', {
          doc_no: this.appraiserFormData.id,
          user_id: 'currentUserId',
          appraisees: appraisees
        }, {
          apiName: 'companyName'
        });
        this.$toast.success('Appraisee added successfully!');
      } catch (error) {
        console.error('Failed to add appraisees:', error);
        this.$toast.error('Failed to add appraisees.');
      }
    },
    
    async submitChanges() {
      try {
        if (this.appraiserFormData.appraiseesQueAddition.length > 0) {
          await this.submitAdditions();
        }
        if (this.appraiserFormData.appraiseesQueDeletion.length > 0) {
          await this.submitDeletions();
        }
        this.appraiserFormData.appraiseesQueAddition = [];
        this.appraiserFormData.appraiseesQueDeletion = [];
        this.$toast.info('All changes submitted successfully!');
      } catch (error) {
        console.error('Failed to submit changes:', error);
        this.$toast.warning('Failed to submit some or all changes.');
      }
    },
    async submitAdditions() {
      try {
        await dynamic_axios.post('/appraisal/add_appraisee', {
          doc_no: this.appraiserFormData.id,
          user_id: 'currentUserId',
          appraisees: this.appraiserFormData.appraiseesQueAddition
        }, {
          apiName: this.appraiserFormData.appr_company
        });
        this.$toast.success('Batch appraisee addition successful!');
      } catch (error) {
        console.error('Failed to add appraisees in batch:', error);
        this.$toast.error('Batch addition failed.');
      }
    },
    async submitDeletions() {
      try {
        await dynamic_axios.post('/delete_appraisee', {
          user_id: 'currentUserId',
          appraisee_ids: this.appraiserFormData.appraiseesQueDeletion
        }, {
          apiName: this.appraiserFormData.appr_company
        });
        this.$toast.success('Batch appraisee deletion successful!');
      } catch (error) {
        console.error('Failed to delete appraisees in batch:', error);
        this.$toast.error('Batch deletion failed.');
      }
    },
    formatName(name) {
      return name.split(" ", 2).join(" ");
    },
  },
  mounted() {    
    this.getAllEmployees();
    // this.$nextTick(() => {
    //     this.fetchAppraisers();
    // });
  }, 
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 300);
  }, 
};
</script>
<style scoped>
.chip-row + .chip-row {
  margin-top: 8px; /* Adds space between rows of chips */
}
</style>

